'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _InputList = require('./InputList');

var _InputList2 = _interopRequireDefault(_InputList);

var _LocationInput = require('./LocationInput');

var _LocationInput2 = _interopRequireDefault(_LocationInput);

var _FileInputList = require('./FileInputList');

var _FileInputList2 = _interopRequireDefault(_FileInputList);

var _FileInputSortableList = require('./FileInputSortableList');

var _FileInputSortableList2 = _interopRequireDefault(_FileInputSortableList);

var _logging = require('../lib/logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formElementFactory = function formElementFactory(type, isList, useFramework7) {

  var InputF7 = void 0,
      LocationInputF7 = void 0;
  if (useFramework7) {
    var _require = require('../components-framework7');

    InputF7 = _require.Input;
    LocationInputF7 = _require.LocationInput;
  }

  switch (type) {
    case 'location':
      return useFramework7 ? LocationInputF7 : _LocationInput2.default;

    case 'file':
      return _FileInputList2.default;

    case 'file-sortable':
      return _FileInputSortableList2.default;

    case 'button':
      return _Button2.default;

    default:
      if (isList) {
        return _InputList2.default;
      }
      return useFramework7 ? InputF7 : _Input2.default;
  }
};

var getFramework7Form = function getFramework7Form(props, inputElements, onSubmit, framework7AppContext) {
  var _require2 = require('../components-framework7'),
      FormF7 = _require2.Form;

  return _react2.default.createElement(
    FormF7,
    {
      inset: false,
      submitButtonLabel: props.submitButtonLabel,
      cancelButtonLabel: props.cancelButtonLabel,
      formTitle: props.formTitle,
      onSubmit: onSubmit,
      onCancel: props.onCancel,
      topElement: props.topElement,
      bottomElement: props.bottomElement,
      framework7AppContext: framework7AppContext,
      submitClassNames: props.submitClassNames
    },
    inputElements
  );
};

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _this.onChange = _this.onChange.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);

    _this.formData = {};
    return _this;
  }

  _createClass(Form, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initForm();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.initForm();
    }
  }, {
    key: 'onChange',
    value: function onChange(obj) {
      var _this2 = this;

      Object.keys(obj).forEach(function (id) {
        _lodash2.default.set(_this2.formData, id, obj[id]);
      });
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      if (event && event.preventDefault) {
        event.preventDefault();
      }
      this.props.onSubmit(this.formData);
    }
  }, {
    key: 'initForm',
    value: function initForm() {
      var _this3 = this;

      /* We are going to overwrite the elements in this.formData only if their value was null or undefined */

      this.props.data.forEach(function (d) {

        if (d.items) {
          d.items.forEach(function (item) {
            var value = _lodash2.default.get(_this3.formData, item.name);

            if (value === null || value === false || typeof value === 'undefined') {
              _lodash2.default.set(_this3.formData, item.name, item.initialValue);
            }
          });
        } else {
          var value = _lodash2.default.get(_this3.formData, d.name);

          if (value === null || value === false || typeof value === 'undefined') {
            _lodash2.default.set(_this3.formData, d.name, d.initialValue);
          }
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          isSaving = _props.isSaving,
          submitContainerClassNames = _props.submitContainerClassNames,
          onCancel = _props.onCancel,
          framework7AppContext = _props.framework7AppContext;


      var customClassNames = this.props.customClassNames || [];

      var baseFormClasses = 'ui form arreebaForm ' + customClassNames.join(' ');

      var formClasses = isSaving ? baseFormClasses + ' loading' : baseFormClasses;

      var submitClassNames = ['positive'];
      if (this.props.submitClassNames) {
        submitClassNames = Array.isArray(this.props.submitClassNames) ? this.props.submitClassNames : [this.props.submitClassNames];
      }

      var cancelButtonLabel = this.props.cancelButtonLabel || 'Annulla';
      var submitButtonLabel = this.props.submitButtonLabel || 'Salva';

      var inputElements = _lodash2.default.map(this.props.data, function (element) {

        if (!element) {
          return null;
        }

        if (element.customComponent) {
          return _react2.default.createElement(
            'div',
            {
              key: element.name,
              name: element.name,
              className: _classnames2.default.apply(undefined, ['field'].concat(_toConsumableArray(element.customClassNames || []), [{ hidden: element.hidden }]))
            },
            element.customComponent
          );
        }

        var elementConfig = _extends({}, element);

        if (elementConfig.removable && !elementConfig.onRemoveItem) {
          (0, _logging.warn)('Found an element with "removable: true" but without the callback "onRemoveItem".', elementConfig);
        }

        if (elementConfig.type === 'file' || elementConfig.type === 'file-sortable') {

          elementConfig.onDrop = function (name, file) {
            _lodash2.default.set(_this4.formData, name, file);
          };

          elementConfig.onRemove = function (name, file) {
            // We want to match 'type' in these example patterns:
            // files.type[0] or type[0]
            var m = name.match(/([^\[].*)\[/)[1].split('.');
            var fileType = m[m.length - 1];

            _lodash2.default.set(_this4.formData, name, undefined);

            if (typeof file === 'string') {

              if (!_this4.formData.removedFilesUrls) {
                _this4.formData.removedFilesUrls = {};
              }
              if (!_this4.formData.removedFilesUrls[fileType]) {
                _this4.formData.removedFilesUrls[fileType] = [];
              }
              if (_this4.formData.removedFilesUrls[fileType].indexOf(file) < 0) {
                _this4.formData.removedFilesUrls[fileType].push(file);
              }
            }
          };
        }

        if (elementConfig.type === 'file-sortable') {
          elementConfig.onSortingChange = function (obj) {
            _this4.onChange(obj);
          };
        }

        var InputComponent = formElementFactory(elementConfig.type, !!elementConfig.items, !!framework7AppContext);

        return _react2.default.createElement(InputComponent, _extends({
          key: element.name
        }, elementConfig, {
          onChange: function onChange(obj) {
            _this4.onChange(obj);
            if (element.onChange) {
              element.onChange(obj);
            }
          },
          errors: _this4.props.errors[element.name]
        }));
      }).filter(function (e) {
        return e;
      }); // filter out null elements

      if (framework7AppContext) {
        return getFramework7Form(this.props, inputElements, this.onSubmit, framework7AppContext);
      }

      return _react2.default.createElement(
        'form',
        { className: formClasses, onSubmit: this.onSubmit },
        inputElements,
        _react2.default.createElement(
          'div',
          { className: 'formButtonsContainer' },
          _react2.default.createElement(
            'div',
            { className: _classnames2.default.apply(undefined, ['ui', 'buttons'].concat(_toConsumableArray(submitContainerClassNames || []))) },
            onCancel && _react2.default.createElement(
              'button',
              { className: 'ui button', type: 'reset', onClick: onCancel },
              cancelButtonLabel
            ),
            _react2.default.createElement(
              'button',
              {
                className: _classnames2.default.apply(undefined, ['ui', 'button'].concat(_toConsumableArray(submitClassNames))),
                type: 'submit'
              },
              submitButtonLabel
            )
          )
        )
      );
    }
  }]);

  return Form;
}(_react.Component);

Form.propTypes = {
  data: _propTypes2.default.array,
  defaultValues: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func.isRequired,
  onSubmitClick: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  isSaving: _propTypes2.default.bool,
  errors: _propTypes2.default.object,
  customClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
  submitClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
  submitContainerClassNames: _propTypes2.default.arrayOf(_propTypes2.default.string),
  cancelButtonLabel: _propTypes2.default.string,
  submitButtonLabel: _propTypes2.default.string,
  topElement: _propTypes2.default.object,
  bottomElement: _propTypes2.default.object,
  framework7AppContext: _propTypes2.default.object
};

exports.default = Form;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/Form.js
// module id = 290
// module chunks = 0